module.exports = __webpack_public_path__ + "static/img/pe.07f3c77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/pe.png
// module id = x1Yf
// module chunks = 18